
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import {
  addArchive,
  cancelCourseTop,
  copyCourse,
  courseCodeReset,
  courseCodeStart,
  courseCodeStop,
  CourseItem,
  semesterItem,
  deleteCourse,
  quitCourse,
  getDeletePattern,
  getCourseList,
  getSemesterList,
  getSemesterCourseList,
  setCourseTop,
  transferCourse,
  getCourseStateAll,
  checkAuth
} from '@/apis/courseList/courseList';
import CourseCell from '@/components/courseCell/courseCell.vue';
import CourseCellPlaceHolder from '@/components/courseCell/courseCellPlaceholder.vue';
import CheckInfoDialog from '@/components/courseCell/checkInfoDialgo.vue';
import { Dialog, Toast } from 'vant';
import { UserInfo } from '@/interfaces/vuexStateInterface';
import SortList from './sortList.vue';
// eslint-disable-next-line import/no-cycle
import { isWechat, objCookie,geMobiletCurrentURL } from '@/utils/common';
import { batchAddClass } from '@/apis/courseDoor';
import { isDemoAccount } from '@/utils/utils';
import { VueRouter } from 'vue-router/types/router';
import { usePathTokenTologin,isCanShowAdCourse } from '@/utils/utils';
import { getWxConfig } from '@/store/checkIn';
import DoubleElevenEvent from './components/DoubleElevenEvent.vue';
import StudentHomeApi from '@/apis/ktpStudentHome';
import { TrackLogType } from '@/interfaces/paycoursetracklog';

import grownPlanLists from '@/views/Home/ktpStudentHome/components/grownPlanLists.vue';
import shelfSoonLists from '@/views/Home/ktpStudentHome/components/shelfSoonLists.vue';
import payBigCourseLists from '@/views/Home/ktpStudentHome/components/payBigCourseLists.vue';
import learningProgress from '@/views/Home/ktpStudentHome/components/learningProgress.vue';
import RecommendAdvertList from '@/views/Home/ktpStudentHome/components/recommendAdvertList.vue';
import RecommendAdvertListV2 from '@/views/Home/ktpStudentHome/components/recommendAdvertListV2.vue';
import i18n from '@/lang/index';
import AdManageApi from '@/apis/advertManage/admanage';
import NotReadNotifyDialog from '@/views/Home/ktpStudentHome/components/notReadNotifyDialog.vue';
import OfficialAccountCard from '@/components/OfficialAccountCard/officialAccountCard.vue';
import BindOtherWechatDialog from '@/components/Wechat/BindWechatDialog/BindOtherWechatDialog.vue';
import BindOtherWechatPopup from '@/components/Wechat/BindWechatDialog/BindOtherWechatPopup.vue';
import ColdKnowlegeCard from '@/components/OfficialAccountCard/ColdKnowlegeCard.vue';

interface ActionSheetItem {
  name: string;
  type?:string;//类型
}

@Component({
  components: {
    CourseCell,
    CourseCellPlaceHolder,
    CheckInfoDialog,
    DoubleElevenEvent,
    SortList,
    grownPlanLists,
    shelfSoonLists,
    payBigCourseLists,
    RecommendAdvertList,
    RecommendAdvertListV2,
    NotReadNotifyDialog,
    OfficialAccountCard,
    BindOtherWechatDialog,
    BindOtherWechatPopup,
    ColdKnowlegeCard
  }
})
export default class KtpCourse extends Vue {
  private placeholderDesc: string = i18n.t('Home.搜索我教的课程') as string;
  private searchViewVisible: boolean = false;
  private firstEntry: boolean = true;
  private searchListData: any = [];
  private searchInner: string = '';
  private isLoading = false;
  private pullRefreshLoading = false;
  private isShowActionsDialog = false;
  private topCourseList: Array<CourseItem> = [];
  private semesterList: Array<semesterItem> = [];
  private isShowActionSheet: boolean = false;
  private isShowMoreBtnActionSheet:boolean = false;
  private actionsArray: Array<ActionSheetItem> = [];
  private moreBtnActionsArray:Array<ActionSheetItem> = [];
  private courseItemCache: CourseItem = { role: 0 } as CourseItem;
  private courseCopyResults: Array<string> = [];
  private courseNameCopy: string = '';
  private courseTransferAccount: string = '';
  private pwdErrMsg = '';
  private userPwd = '';
  private filedType: '0' | '1' = '0';
  private actionCourseItemType:string|undefined = '';
  private actionCourseItemName:string = '';
  private actionDialogTitle = '';
  private actionDialogConfirmText = i18n.t('Common.确定');
  private actionDialogCancelText = i18n.t('Common.取消');
  private deleteCoursePlaceholder = i18n.t('Home.请输入登录密码验证');
  private deleteCourseWay = 0;//删除模式
  // 资料上报
  private checkInfoShow = false;
  private roleobj: any = {};
  private checkedCourseId = '';
  private createdCourseNums = 0; // 创建的课程数
  private isvip = false;
  private isstudyTbs = '1'; //1我教的 0我学的
  private activeVal = '1'; //默认展开卡片
  private inSetSort = false; //是否拖拽
  private sortlistData: any = {
    list: [],
    item: {}
  };
  private courseStateAll = []; //当前上课数量
  private banner = []; //banner图片
  private courseActiveNames = ['0'];
  private isWechatClient = isWechat; //是否是微信浏览器
  private currentTime:number = Date.now()/1000;

  private isExpandAllTermLists:boolean = false;//是否展开所有的学期
  private isCanShowAdCourseLists:boolean = false;//是否可以展示推广的课程

  private otherCourseActiveName = "1";

  private notReadNotifyLists:any = [];

  private wechatOtherBindState:number = 100;

  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo;
  }

  //下拉刷新
  onRefreshPullRefresh() {
    this.getCourseList().then(() => {
      Toast(i18n.t('Common.刷新成功'));
      this.pullRefreshLoading = false;
    });
  }

  gotoUrl(item:any) {
    if(item.url != null && item.url!=null && item.url.length>0){
        if(item.id != undefined && item.id != ""){
          StudentHomeApi.trackLog({
            type: TrackLogType.BANNER,
            event_id: item.id,
            residence_time:(Date.now()/1000 - this.currentTime),
          }).then((res:any)=>{
              const localtion: any = window.location;
              localtion.href = item.url;
          });
        }else{
          const localtion: any = window.location;
          localtion.href = item.url;
        }
    }else if(item.type == 'weapp'){
        this.$router.push('/smallProgram');
    }
  }

  handleCourseHeaderAction() {
    const tempActionsArray: Array<ActionSheetItem> = [];
    tempActionsArray.push({ name: i18n.t('Home.Handle.加入课程') as string, type:'join'});
    if (this.$store.getters.getUserInfo.usertype === '1') {
      tempActionsArray.push({ name: i18n.t('Home.Handle.创建课程') as string, type:'create'});
      if (isDemoAccount(this.$store.getters.getUserInfo.id)) {
        tempActionsArray.push({ name: i18n.t('Home.Handle.从示范包创建') as string, type:'createfromdemo'});
      }
    }
    tempActionsArray.push({ name: i18n.t('Home.Handle.归档管理') as string , type:'archivemanage'});
    this.actionsArray = tempActionsArray;
    this.isShowActionSheet = true;
  }

  handleItemMoreActions(item: CourseItem) {
    this.courseItemCache = item;
    let tempActionsArray: Array<any> = [];
      if (Number(item.role) == 1) {
        tempActionsArray = [
          { name: i18n.t('Common.编辑') as string,  type:'edit' },
          { name: i18n.t('Common.删除') as string,  type:'delete' },
          { name: i18n.t('Common.归档') as string,  type:'archive' },
          { name: i18n.t('Common.复制') as string,  type:'copy' },
          { name: i18n.t('Common.转让') as string,  type:'transfer' }
        ];
      }
      if (Number(item.role) == 0) {
        tempActionsArray = [
          { name: i18n.t('Common.退课') as string, type:'exitcourse' },
          { name: i18n.t('Common.归档') as string, type:'archive' }
        ];
      }

      if(item.icontype == 2) {
        // 助教
        tempActionsArray = [
          { name: i18n.t('Common.编辑') as string, type:'edit' },
          { name: i18n.t('Common.归档') as string, type:'archive' },
          { name: i18n.t('Common.复制') as string, type:'copy' }
        ];
      }

      if(parseInt(item.identity) == 4) {
        tempActionsArray = [
          { name: i18n.t('Common.归档') as string, type:'archive'}
        ];
      }

      if (item.isTop == 0) {
        tempActionsArray.push(
          {
            name:  i18n.t('Common.置顶') as string,
            type: 'settop'
          }
        );
      } else if (item.isTop === 1) {
        tempActionsArray.push({ name: i18n.t('Common.取消置顶') as string, type:'cancletop' });
      }
      this.actionsArray = tempActionsArray;
      this.isShowActionSheet = true;
  }

  handleItemCodeActions(item: CourseItem) {
    this.courseItemCache = item;
    if (item.stopcode === 1) {
      this.actionsArray = [
        { name: i18n.t('Common.启用加课码') as string, type:'enableJoinCode' }
      ];
    } else if (item.stopcode === 0) {
      this.actionsArray = [
        { name: i18n.t('Common.重置加课码') as string, type:'resetJoinCode' },
        { name: i18n.t('Common.停用加课码') as string, type:'stopJoinCode' }
      ];
    }
    this.isShowActionSheet = true;
  }

  onSelect(item: ActionSheetItem) {
    this.actionCourseItemType = item.type;
    this.actionCourseItemName = item.name;
    switch (item.type) {
      case 'create':
        if (this.createdCourseNums > 10 && !this.isvip) {
          this.$dialog
            .confirm({
              title: i18n.t('CommonComponents.Vipdg.是否开通会员') as string,
              message: i18n.t('CommonComponents.Vipdg.非VIP最多可创建10个课程包含删除和归档的课程您的课程已达到上限开通VIP可继续创建课程并且无上线另外VIP可尊享更多权益') as string,
              confirmButtonText: i18n.t('CommonComponents.Vipdg.开通VIP') as string
            })
            .then(() => {
              this.$router.push({
                path: '/vipManagement'
              });
            })
            .catch(() => {
              // on cancel
            });
        } else {
          this.$router.push('/newCourse');
        }

        break;
      case 'join':
        this.$router.push('/joinCourses');
        break;
      case 'archivemanage':
        this.$router.push('/filedCourse');
        break;
      case 'edit':
        this.$router.push({
          path: '/newCourse',
          query: { id: this.courseItemCache.id } }
        );
        break;
      case 'delete':
        this.handleCourseDelete();
        break;
      case 'archive':
        this.handleCourseFiled();
        break;
      case 'exitcourse':
        this.handleCourseRetired();
        break;
      case 'copy':
        this.handleCourseCopy();
        break;
      case 'transfer':
        this.handleCourseTransfer();
        break;
      case 'settop':
        this.handleCourseSetTop();
        break;
      case 'cancletop':
        this.handleCourseCancelTop();
        break;
      case 'resetJoinCode':
        this.handleResetCode();
        break;
      case 'stopJoinCode':
        this.handleStopCode();
        break;
      case 'enableJoinCode':
        this.handleOpenCode();
        break;
      case 'createfromdemo':
        this.$router.push('/createCourseFromDemo');
        break;
    }
    this.isShowActionSheet = false;
  }

  //更多按钮的
  onMoreBtnSelect(item: ActionSheetItem){
    this.actionCourseItemType = item.type;
    this.actionCourseItemName = item.name;
    switch (item.type) {
      case 'archivemanage':
        this.archiveManagement();
        break;
    }
    this.isShowMoreBtnActionSheet = false;
  }

  handleResetCode() {
    courseCodeReset(this.courseItemCache.id)
      .then((res) => {
        Toast(i18n.t('Home.加课码已重置') as string);
        this.getCourseList();
      })
      .catch((e) => {
        Toast(e.message);
      });
  }

  handleStopCode() {
    courseCodeStop(this.courseItemCache.id)
      .then((res) => {
        Toast(i18n.t('CourseHome.加课码已停用') as string);
        this.getCourseList();
      })
      .catch((e) => {
        Toast(e.message);
      });
  }

  handleOpenCode() {
    courseCodeStart(this.courseItemCache.id)
      .then((res) => {
        Toast(i18n.t('CourseHome.加课码已启用') as string);
        this.getCourseList();
      })
      .catch((e) => {
        Toast(e.message);
      });
  }

  handleCourseDelete() {
    Dialog.confirm({
      title: i18n.t('Common.删除提示') as string,
      message: `${i18n.t('Home.确定要删除')}"<span style="color: #4285F4">${this.courseItemCache.coursename}</span>"？`
    })
      .then(() => {
        getDeletePattern({courseid:this.courseItemCache.id}).then((res:any)=>{
          if(res.deleteway == 1){
            this.deleteCoursePlaceholder = i18n.t('Home.请按照提示输入');
            this.deleteCourseWay = 1;
          }else{
            this.deleteCourseWay = 0;
          }
          this.actionDialogTitle = i18n.t('Home.删除后数据将无法恢复') as string;
          this.actionDialogCancelText = i18n.t('Home.确定删除')  as string;
          this.actionDialogConfirmText = i18n.t('Home.再想想')  as string;
          this.isShowActionsDialog = true;
        });
      })
      .catch();
  }

  deleteCourse() {
    this.pwdErrMsg = '';
    deleteCourse({
      courseid: this.courseItemCache.id,
      password: this.userPwd
    })
      .then((res) => {
        this.closeActionsDialog();
        Dialog.alert({
          title: `${this.actionCourseItemName}${i18n.t('Home.成功')}`,
          message: `${i18n.t('Home.课程')}"${this.courseItemCache.coursename}"${this.actionCourseItemName}${i18n.t('Home.成功')}`
        });
        this.getCourseList();
      })
      .catch((e) => {
        console.log(e);
        this.pwdErrMsg = e.message;
      });
  }

  //退课操作
  onQuitCourse(){
    this.pwdErrMsg = '';
    quitCourse({
      courseid: this.courseItemCache.id,
      password: this.userPwd
    })
      .then((res) => {
        this.closeActionsDialog();
        Dialog.alert({
          title: `${this.actionCourseItemName}${i18n.t('Home.成功')}`,
          message: `${i18n.t('Home.课程')}"${this.courseItemCache.coursename}"${this.actionCourseItemName}${i18n.t('Home.成功')}`
        });
        this.getCourseList();
      })
      .catch((e) => {
        console.log(e);
        this.pwdErrMsg = e.message;
      });
  }

  handleCourseRetired() {
     getDeletePattern({courseid:this.courseItemCache.id}).then((res:any)=>{
          if(res.deleteway == 1){
            this.deleteCoursePlaceholder = i18n.t('Home.请按照提示输入') as string;
            this.deleteCourseWay = 1;
          }else{
            this.deleteCourseWay = 0;
          }
          this.actionDialogTitle = `${i18n.t('Home.确定要退课')}'${this.courseItemCache.coursename}'?`;
          this.actionDialogCancelText = i18n.t('Common.退课') as string;
          this.actionDialogConfirmText = i18n.t('Common.取消') as string;
          this.isShowActionsDialog = true;
    });
  }

  handleCourseCopy() {
    this.actionDialogTitle = i18n.t('Common.系统提示') as string;
    this.actionDialogCancelText = i18n.t('Common.取消') as string;
    this.actionDialogConfirmText = i18n.t('Common.确定复制') as string;
    this.isShowActionsDialog = true;
  }

  copyCourse() {
    this.pwdErrMsg = '';
    if (this.courseNameCopy === '') {
      this.pwdErrMsg = i18n.t('Home.请输入课程名') as string;
      return;
    }
    copyCourse({
      coursename: this.courseNameCopy,
      srcCourseid: this.courseItemCache.id,
      copymember: this.courseCopyResults.find((item) => /student/.test(item)) ? 1 : 0,
      copyteacher: this.courseCopyResults.find((item) => /teacher/.test(item)) ? 1 : 0,
      copycourseware: this.courseCopyResults.find((item) => /courseware/.test(item)) ? 1 : 0,
      copyweblink: this.courseCopyResults.find((item) => /weblink/.test(item)) ? 1 : 0
    })
      .then(() => {
        Dialog.alert({
          title: `${this.actionCourseItemName}${i18n.t('Home.成功')}`,
          message: `${this.actionCourseItemName} ${this.courseItemCache.coursename} ${i18n.t('Home.成功')}`
        });
        this.closeActionsDialog();
        this.getCourseList();
      })
      .catch((e) => {
        this.pwdErrMsg = e.message;
      });
  }

  handleCourseFiled() {
    this.actionDialogTitle = i18n.t('Home.要归档管理此课程吗') as string;
    this.actionDialogConfirmText = i18n.t('Common.归档');
    this.filedType = '0';
    this.isShowActionsDialog = true;
  }

  filedCourse() {
    addArchive({
      courseid: this.courseItemCache.id,
      icontype: this.courseItemCache.icontype,
      type: this.filedType
    })
      .then(() => {
        this.closeActionsDialog();
        Dialog.alert({ title: i18n.t('Home.归档成功') as string });
        this.getCourseList();
      })
      .catch((e) => {
        Dialog.alert({
          title: i18n.t('Home.删除失败') as string,
          message: e.message
        });
      });
  }

  handleCourseTransfer() {
    getDeletePattern({courseid:this.courseItemCache.id}).then((res:any)=>{
      if(res.deleteway == 1){
        this.deleteCoursePlaceholder = i18n.t('Home.请按照提示输入') as string;
        this.deleteCourseWay = 1;
      }else{
        this.deleteCourseWay = 0;
      }
      this.actionDialogTitle          = i18n.t('Common.系统提示') as string;
      this.actionDialogCancelText     = i18n.t('Common.取消') as string;
      this.actionDialogConfirmText    = i18n.t('Common.确定') as string;
      this.isShowActionsDialog        = true;
    });
  }

  transferCourse() {
    if (!this.userPwd) {
      //this.pwdErrMsg = '请输入您的密码';
      //return;
    }
    if (!this.courseTransferAccount) {
      this.pwdErrMsg = i18n.t('Home.请输入要转让的老师的账号') as string;
      return;
    }
    transferCourse({
      account: this.courseTransferAccount,
      password: this.userPwd,
      courseid: this.courseItemCache.id
    })
      .then(() => {
        this.closeActionsDialog();
        Dialog.alert({ title: i18n.t('Home.转让成功') as string });
        this.getCourseList();
      })
      .catch((e) => {
        this.pwdErrMsg = e.message;
      });
  }

  handleCourseSetTop() {
    setCourseTop({
      courseid: this.courseItemCache.id,
      icontype: this.courseItemCache.icontype,
    })
      .then(() => {
        this.getCourseList();
      })
      .catch((e) => {
        Dialog.alert({ title: e.message });
      });
  }

  handleCourseCancelTop() {
    cancelCourseTop({
      courseid: this.courseItemCache.id,
      icontype: this.courseItemCache.icontype
    })
      .then(() => {
        this.getCourseList();
      })
      .catch((e) => {
        Dialog.alert({ title: e.message });
      });
  }

  closeActionsDialog() {
    this.isShowActionsDialog = false;
    this.actionDialogConfirmText = i18n.t('Common.确定') as string;
    this.actionDialogCancelText = i18n.t('Common.取消') as string;
    this.actionDialogTitle = '';
    this.pwdErrMsg = '';
    this.userPwd = '';
    this.courseCopyResults = [];
    this.courseNameCopy = '';
    this.courseTransferAccount = '';
  }

  actionsDialogConfirm() {
    switch (this.actionCourseItemType) {
      case 'delete':
        this.closeActionsDialog();
        break;
      case 'archive':
        this.filedCourse();
        break;
      case 'copy':
        this.copyCourse();
        break;
      case 'exitcourse':
        this.closeActionsDialog();
        break;
      case 'transfer':
        this.transferCourse();
        break;
      default:
        this.closeActionsDialog();
    }
  }

  actionDialogCancel() {
    switch (this.actionCourseItemType) {
      case 'delete':
        this.deleteCourse();
        break;
      case 'exitcourse':
        this.onQuitCourse();
        break;
      default:
        this.closeActionsDialog();
    }
  }

  actionsDialogBeforeClose(action: Function, done: Function) {
    done(false);
  }

  async getCourseList(search?: string) {
    this.$toast.loading({ forbidClick: true });
    this.isLoading = true;
    let params = {
      isstudy: this.isstudyTbs === '1' ? '0' : this.isstudyTbs === '2' ? '2' : '1',
      search: search ? search : ''
    };
    await getSemesterList(params).then((res: any) => {
      this.$toast.clear();
      this.isLoading = false;
      this.topCourseList = res.topcourses;
      if (res.semester.length) {
        res.semester.forEach((item: any) => {
          item.unfold = false;
          item.list = [];
        });
        res.semester[0].unfold = true;
        this.semesterList = res.semester;
        this.getSemesterCourseList(res.semester[0], 0);
      }
      // 是否弹出机构认证【0不弹出1弹出认证2弹出课程认证】
      if (res.isPopApprove!=undefined && res.isPopApprove!=null && res.isPopApprove != '0') {
        this.judgeOrganizationNeedsAuthentication(res.isPopApprove);
      }
    });

    await getCourseStateAll().then((res: any) => {
      this.courseStateAll = res.list;
      this.banner = res.banner;
      this.notReadNotifyLists = res.notReadNotifyLists;
    });
  }

  async getSemesterCourseList(item: any, index: number) {
    this.isLoading = true;
    let params = {
      isstudy: this.isstudyTbs === '1' ? '0' : this.isstudyTbs === '2' ? '2' : '1',
      search: '',
      semester: item.semester,
      term: item.term
    };
    await getSemesterCourseList(params).then((res: any) => {
      this.semesterList[index].list = res;
      this.sortlistData.list = res;
      this.isLoading = false;
    });
  }

  // 完善资料弹窗
  checkInfoEmit(data: any) {
    this.roleobj = data.roleobj;
    this.checkedCourseId = data.courseId;
    this.checkInfoShow = true;
  }

  // 完善资料成功事件
  // ...check
  onSuccess() {
    // 完善成功，跳转到课程首页
    this.$router.push({
      path: '/courseHome',
      query: {
        courseId: this.checkedCourseId
      }
    });
  }

  doInitSmallProgram(){
    let newUrl = geMobiletCurrentURL();
    getWxConfig({url:newUrl}).then((config:any) => {
      // @ts-ignore
      // eslint-disable-next-line no-undef
      wx.config({
        debug: false,
        appId: config.appId,
        timestamp: config.timestamp,
        nonceStr: config.nonceStr,
        signature: config.signature,
        jsApiList: ['wx-open-launch-weapp'], // 必填，需要使用的JS接口列表
        openTagList: ['wx-open-launch-weapp'] // 可选，需要使用的开放标签列表
      });
      // @ts-ignore
      // eslint-disable-next-line no-undef
      wx.ready(function () {
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
      });
      // @ts-ignore
      // eslint-disable-next-line no-undef
      wx.error(function (res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名
      });
    });
  }

  created() {
    const tempActionsArray: Array<ActionSheetItem> = [];
    tempActionsArray.push({ name: i18n.t('Home.Handle.归档管理') as string , type:'archivemanage'});
    this.moreBtnActionsArray = tempActionsArray;

    usePathTokenTologin();
    if (sessionStorage.courseids && sessionStorage.coid) {
      this.isMechanism();
    }
    // 来自其他页面
    if(sessionStorage.from) {
      open(decodeURIComponent(sessionStorage.from) + `&portalToken=${ localStorage.token }`, '_self');
      sessionStorage.removeItem('from');
    }
    this.isCanShowAdCourseLists = isCanShowAdCourse(this.userInfo.school as string);
    // eslint-disable-next-line no-unneeded-ternary
    this.isstudyTbs = this.$store.getters.getUserInfo.usertype;
    this.isvip = Number(this.$store.getters.getUserInfo.isvip) ? true : false;
    this.getCourseList();
    this.doInitSmallProgram();
  }

  mounted() {
    if (!this.userInfo.openid && isWechat) {
      let msg = "";
      msg = "<div style='text-align:left;'>当前用户<span style='color:red;'>没有绑定微信</span>，请前去绑定！</div><div style='text-align:left;'>绑定微信后，您可以通过微信接受<span style='color:blue;'>课堂通知</span>，<span style='color:blue;'>作业提醒</span>，<span style='color:blue;'>互动提醒</span>等</div>";
      if(this.userInfo.usertype == "1"){
        msg = "<div style='text-align:left;'>当前用户<span style='color:red;'>没有绑定微信</span>，请前去绑定！</div><div style='text-align:left;'>绑定微信后，您可以通过微信接受<span style='color:blue;'>教学活动通知</span>，<span style='color:blue;'>私信提醒</span>等</div>";
      }
      this.$dialog.confirm({
        title: i18n.t('Common.系统提示') as string,
        message: msg,
        allowHtml:true,
        confirmButtonText:i18n.t('Home.前往绑定') as string,
      }).then(() => {
        this.$router.push('/accoundNumberInfo?bind=wechat&open=1');
      });
    }
  }

  //获取tabs
  getTabsName(name: string) {
    //this.topCourseList = [];
    this.semesterList = [];
    this.getCourseList();
  }

  //获取展开
  getCollapseName(item: any, index: number) {
    let listArr = this.semesterList;
    this.semesterList[index].unfold = !item.unfold;
    if (item.unfold) {
      this.getSemesterCourseList(item, index);
    }
  }

  searchType() {
    this.searchListData = [];
    this.searchViewVisible = true;
    if (this.isstudyTbs == '1') {
      this.placeholderDesc = i18n.t('Home.搜索我教的课程') as string;
    } else {
      this.placeholderDesc = i18n.t('Home.搜索我学的课程') as string;
    }
  }
  archiveManagement(){
    this.$router.push('/filedCourse');
  }
  inputText() {

    this.getSearchList();
  }

  onCancelSearch() {
    this.searchInner = '';
    this.getSearchList();
  }

  getSearchList() {
    this.firstEntry = false;
    this.isLoading = true;
    let params = {
      isstudy: this.isstudyTbs === '1' ? '0' : '1',
      search: this.searchInner ? this.searchInner : '',
      semester: '',
      term: ''
    };
    getSemesterCourseList(params).then((res) => {
      this.searchListData = res;
      this.isLoading = false;
    });
  }

  //是否拖拽
  setSortList(item: any, index: number) {
    this.getSemesterCourseList(item, index).then(() => {
      this.sortlistData.item = item;
      this.inSetSort = true;
    });
  }

  //关闭拖拽窗口
  closeSort() {
    this.inSetSort = false;
    this.getCourseList();
  }

  //进入课程
  handleDetails(itemData: any) {
    this.$store.commit('setCourseRole', String('0'));
    if(typeof(itemData.is_meeting) === 'string' && itemData.is_meeting.length > 1 && itemData.type == '0') {
      this.$router.push({
        path: '/conference',
        query: {
          courseId: itemData.id,
          id: itemData.is_meeting,
          courseRole: this.userInfo.usertype
        }
      });
      return;
    }
    // 学生判断权限
    checkAuth(itemData.id).then((res) => {
      if (res.state === 0) {
        if (res.userInfo.grade === '0') {
          res.userInfo.grade = '';
        }
        const roleobj = {
          classno: res.userInfo.classno,
          grade: res.userInfo.grade,
          enrolltime: res.userInfo.enrolltime
        };
        let data = {
          roleobj: roleobj,
          courseId: itemData.id
        };
        this.checkInfoEmit(data);
      } else {
        window.sessionStorage.setItem('courseId', itemData.id);
        this.$router.push(`/courseHome?courseId=${itemData.id}&courseRole=0`);
      }
    });
  }

  // 添加选课课程
  async addCourse() {
    const params = {
      courseid: sessionStorage.courseids
    };
    batchAddClass(params).then(async (res: any) => {
      await Dialog.confirm({
        title: i18n.t('Home.成功') as string,
        message: `${i18n.t('Home.已成功加入')} ${sessionStorage.courseids.split(',').length} ${i18n.t('Common.个课程')}`,
        confirmButtonText: i18n.t('conference.知道了') as string,
        showCancelButton: false
      });
      sessionStorage.removeItem('courseids');
      sessionStorage.removeItem('coid');
    });
  }

  // 获取用户信息 判断是否认证
  async isMechanism() {
    if (this.$store.state.userInfo.atteststate === '1') {
      await this.addCourse();
    } else {
      this.goMechanism();
    }
  }

  goMechanism() {
    Dialog.confirm({
      message: i18n.t('Common.请先进行身份认证') as string,
      cancelButtonText: i18n.t('Common.取消') as string,
      confirmButtonText: i18n.t('Common.立即认证') as string
    }).then(() => {
      this.$router.push({
        path: '/myAllSetting',
        query: {
          detail: 'myMechanism'
        }
      });
    }).catch(() => {
      this.$router.push({
        path: '/courseDoor',
        query: {
          coid: sessionStorage.coid
        }
      });
      sessionStorage.removeItem('courseids');
      sessionStorage.removeItem('coid');
    });
  }

  // 判断机构是否需要认证
  judgeOrganizationNeedsAuthentication(num: any) {
    // 以后再说
    if (objCookie.getCookie('isAuthentication') === '0' || sessionStorage.isAuthentication == '0') {
      if(num == 1 || num == "1"){ //1表示身份认证  2表示课程认证
        return;
      }
    }
    //1表示身份认证
    if(num == 1){
      //这里进行弹窗提示处理
      this.$dialog
        .confirm({
          title: i18n.t('Common.系统提示') as string,
          message: "您所在的学校已开通机构后台功能，需要完成身份认证!!",
          cancelButtonText: "以后再说",
          confirmButtonText: "立即认证"
        })
        .then(() => {
          this.pageJump(num);
        })
        .catch(() => {
          sessionStorage.isAuthentication = '0';
          const expires = (8.64e7 - Date.now() % 8.64e7) / 8.64e7;
          objCookie.setCookie('isAuthentication', '0', expires);
        });
    }
  }

  // 机构需要认证的页面跳转
  pageJump(num: any) {
    let obj: any = {
      path: '/myAllSetting',
      query: {
        detail: 'myMechanism',
        atteststate: num
      }
    };
    this.$router.push(obj);
  }

  //控制展开和收起所有的课程列表
  explandTermLists(){
    this.isExpandAllTermLists = !this.isExpandAllTermLists;
  }

  destroyed() {
    sessionStorage.removeItem('isAuthentication');
  }

  gotoDiscover(){
    AdManageApi.collectPageLog({location:4}).then((res1:any)=>{});
    this.$router.push({
      path:"/discover",
    })
  }

  wechatOtherBindStateCallback(state:number){
    this.wechatOtherBindState = state;
  }
}
